/**
 * Whether the provided ID is for GA v4.
 *
 * See https://support.google.com/analytics/answer/9964640#automatically-map-events
 *
 * If false it is likely a Universal Analytics ID.
 */
export const isGaV4Id = (id: string | null): boolean | undefined => id?.toUpperCase().startsWith('G-');
